import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import lazyFn from "@/util/lazy-fn.mjs";

const fetchWikiData = lazyFn(
  () => import("@/game-destiny2/fetches/fetch-wiki-data.mjs"),
);
const profileFetchData = lazyFn(
  () => import("@/game-destiny2/fetches/profile-fetch-data.mjs"),
);
const matchFetchData = lazyFn(
  () => import("@/game-destiny2/fetches/match-fetch-data.mjs"),
);
const oauthRedirectFetchData = lazyFn(
  () => import("@/game-destiny2/fetches/oauth-redirect-fetch-data.mjs"),
);
const allPagesFetchData = lazyFn(
  () => import("@/game-destiny2/fetches/all-page-fetch-data.mjs"),
);
const loadoutFetchData = lazyFn(
  () => import("@/game-destiny2/fetches/fetch-character-loadout.mjs"),
);

const routes: BaseRoute[] = [
  {
    path: /\/destiny2\/profile\/(?<profileId>[\w\-_.~]+)(?:\/(?<tab>[\w\-_.~]+))?/,
    component: "game-destiny2/Profile.tsx",
    fetchData: profileFetchData,
  },
  {
    path: "/destiny2/in-game",
    component: "game-destiny2/InGame.tsx",
  },
  {
    path: "/destiny2/settings",
    component: "game-destiny2/Accounts.tsx",
  },
  {
    path: /\/destiny2\/match\/(?<profileId>[\w\-_.~]+)(?:\/(?<seasonId>[\w\-_.~]+))(?:\/(?<matchId>[\w\-_.~]+))/,
    component: "game-destiny2/Match.tsx",
    fetchData: matchFetchData,
  },
  {
    path: "/bungie-oauth-redirect",
    component: "game-destiny2/OAuthRedirect.tsx",
    fetchData: oauthRedirectFetchData,
  },
  {
    path: "/destiny2/database",
    redirect: "/destiny2/database/weapons",
  },
  {
    path: /\/destiny2\/database\/weapons(?:\/(?<weaponId>[\w\-_.~]+))?(?:\/(?<slug>[\w\-_.~]+))?/,
    component: "game-destiny2/DatabaseWeapons.tsx",
    fetchData: () => fetchWikiData({ armor: true }),
  },
  {
    path: /\/destiny2\/database\/armor(?:\/(?<armorId>[\w\-_.~]+))?(?:\/(?<slug>[\w\-_.~]+))?/,
    component: "game-destiny2/DatabaseArmor.tsx",
    fetchData: () => fetchWikiData({ weapons: true }),
  },
  {
    path: /\/destiny2\/loadout-builder(?:\/(?<tab>[\w\-_.~]+))?/,
    component: "game-destiny2/LoadoutBuilder.tsx",
    fetchData: loadoutFetchData,
  },
  {
    path: /\/destiny2\/faq/,
    component: "game-destiny2/FAQ.tsx",
  },
];

// The catch-all route should be used for fetching any general static data that is
// related to the routes.
routes.push({
  [catchAllRoutes]: routes,
  fetchData: allPagesFetchData,
});

export default routes;
